document.addEventListener('DOMContentLoaded', setUpOnlineSizing);

function setUpOnlineSizing() {
  ((win, doc, script, key, config, src) => {
    win['___OnlineSizing'] = key;
    win['___OnlineSizingConfig'] = config;
    const js = doc.createElement(script);
    js.id = key;
    js.src = src;
    js.defer = true;
    const scripts = doc.getElementsByTagName(script);
    const lastScript = scripts[scripts.length - 1];
    lastScript.parentNode.insertBefore(js, lastScript);
  })(
    window,
    document,
    'script',
    'oz',
    window.settings.online_sizing,
    `https://widgets.onlinesizing.bike/loader.js`
  );
}
